var $ca2ffb0adac8e2d5$exports = {};
$ca2ffb0adac8e2d5$exports = {
    "decrease": (args)=>`Smanji ${args.fieldLabel}`,
    "increase": (args)=>`Pove\u{107}aj ${args.fieldLabel}`,
    "numberField": `Polje broja`
};


export {$ca2ffb0adac8e2d5$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
